module.exports = __webpack_public_path__ + "img/laying-spaccamattone-off.c190ee8a.svg";